import { Component } from '@angular/core';
import { BotaoRedeSocialComponent } from '../botao-rede-social/botao-rede-social'
import { BrComService } from '../../service/BrComService'
/**
 * Generated class for the BotaoTwitterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'botao-twitter',
  templateUrl: '../botao-rede-social/botao-rede-social.html'
})
export class BotaoTwitterComponent extends BotaoRedeSocialComponent{

  protected backgroundColor: string;
  protected icon: string;
  protected label: string;

  constructor(private brcomService: BrComService) {
    super()
    this.backgroundColor = "#4099FF";
    this.icon = "logo-twitter";
    this.label = "Twitter";
  }

  protected async abrirRedeSocial() {
    this.brcomService.abrePaginaNoBrowser(this.link);
  }

}



// WEBPACK FOOTER //
// ./src/components/botao-twitter/botao-twitter.ts